export const deliveryCutoffOptions = [
  ...Array.from({ length: 7 }, (_, index) => {
    const hours = index + 1
    return { id: hours, name: `${hours} ${hours === 1 ? 'hour' : 'hours'}` }
  }),
  { id: 8, name: '1 business day' },
  { id: 12, name: '1.5 business days' },
  { id: 16, name: '2 business days' },
  { id: 20, name: '2.5 business days' },
  { id: 24, name: '3 business days' },
]

export const deliveryCutoffOverrideOptions = [
  { id: 'location_default', name: 'Same as location' },
  ...deliveryCutoffOptions,
]
